import React, {
  FC, useEffect,
} from 'react';
import { v4 as uuid } from 'uuid';
import {
  RowLeft,
} from '../Styles';
import UserReply from '../components/Reply/UserReply';
import { getFoodifoxDataLazy } from '../../../../../lib/axios/FoodifoxDataAPI';
import Q2_1 from '../Q2_1';
import Q2_2 from '../Q2_2';
import OptionButton from '../components/Button/OptionButton';
import RobotReply from '../components/Reply/RobotReply';
import { getWindowWidth, lang } from '../../../../../lib/utils/utils';
import LeftToRight from '../components/Animation/LeftToRight';
import { addSystemLog } from '../../../../../lib/SystemLogUtils';
import RobotLoading from '../components/Loading/RobotLoading';
import TempFieldUtils from '../../../../../lib/TempFieldUtils';

/**
 * 熊猫外卖、饭团外卖进入Q2
 */
const Q2: FC<Props> = ({
  addElement,
  cabId,
  h5Platform,
  setTargetPage,
  setIsToSelectLockerPage,
  deviceCode,
  sessionId,
  enterPhoneNumber,
}) => {
  // 选项
  const options: {key: string; zhValue: string; enValue: string}[] = [
    { key: '2-1', zhValue: '我还没有注册', enValue: 'I haven’t signed-up' },
    { key: '2-2', zhValue: '我已经注册了，但没有收到短信', enValue: 'I have registered but didn’t receive a pick-up SMS' },
    { key: '2-2', zhValue: '取件二维码打不开柜门', enValue: 'The pick-up QR code, didn’t open the door' },
  ];
  // 检查柜子是否在线
  const [getCabOnline] = getFoodifoxDataLazy<boolean>('/fox3PDAi/cabOnlineStatus?cabId=' + cabId);

  const send = (key: string) => {
    if (key === '2-1') {
      addElement(
        <Q2_1
          cabId={cabId}
          h5Platform={h5Platform}
          addElement={addElement}
          setTargetPage={setTargetPage}
          setIsToSelectLockerPage={setIsToSelectLockerPage}
          deviceCode={deviceCode}
          sessionId={sessionId}
        />
      );
      return;
    }

    const loadingFlowId = uuid();
    addElement(
      <RowLeft>
        <RobotLoading flowId={loadingFlowId} />
      </RowLeft>
    );

    // 检测cab是否在线
    getCabOnline({
      param: {
        cabId,
      },
      onCompleted(isOnline) {
        setTimeout(() => {
          // 隐藏loading
          TempFieldUtils.aiFlowIds.push(loadingFlowId);
        }, 2000);
        setTimeout(() => {
          addElement(
            <Q2_2
              cabId={cabId}
              cabIsOnline={isOnline}
              h5Platform={h5Platform}
              addElement={addElement}
              setTargetPage={setTargetPage}
              setIsToSelectLockerPage={setIsToSelectLockerPage}
              deviceCode={deviceCode}
              sessionId={sessionId}
              enterPhoneNumber={enterPhoneNumber}
            />
          );
        }, 2200);
      },
    });
  };

  useEffect(() => {
    // 流程ID，同一个流程下的按钮，只要点击了一次就加入到流程ID中，避免重复点击
    const flowId = uuid();
    const langZh = '您在取件方面遇到了什么问题？';
    const langEn = 'What pick-up issue are you having?';
    addElement(
      <LeftToRight flowId={flowId}>
        <RowLeft style={{ marginTop: 25 }}>
          <RobotReply
            style={{ maxWidth: 'unset', width: lang(getWindowWidth() * 0.57, getWindowWidth() * 0.58) }}
            langZh={langZh}
            langEn={langEn}
          />
        </RowLeft>
      </LeftToRight>
    );

    // 机器人回复日志
    addSystemLog(cabId, deviceCode, h5Platform + '', 'Q2 - bot: ' + langEn, sessionId);

    setTimeout(() => {
      addElement(
        <LeftToRight flowId={flowId}>
          {
            options.map(({ key, zhValue, enValue }) => {
              return (
                <RowLeft key={key + '' + (new Date().getTime())}>
                  <OptionButton
                    langZh={(
                      (
                        <div style={{ width: 229, textAlign: 'center' }}>
                          { zhValue }
                        </div>
                      )
                    )}
                    langEn={(
                      <div style={{ width: 219, textAlign: 'center' }}>
                        { enValue }
                      </div>
                    )}
                    flowId={flowId}
                    callback={() => {
                      // 用户回复日志
                      addSystemLog(cabId, deviceCode, h5Platform + '', 'Q2 - user: ' + enValue, sessionId);
                      addElement(
                        <UserReply
                          langZh={zhValue}
                          langEn={enValue}
                        />
                      );
                      send(key);
                    }}
                  />
                </RowLeft>
              );
            })
          }
        </LeftToRight>
      );
    }, 200);
  }, []);

  return (
    <></>
  );
};

export interface Props {
  cabId: number;
  h5Platform: number;
  addElement: (elements: any) => void;
  setTargetPage: (targetPage: string) => void;
  setIsToSelectLockerPage?: (isToLockerPage: boolean) => void;
  deviceCode: string;
  sessionId: string;
  // 进入AI对话的用户手机号
  enterPhoneNumber: string;
}

export default Q2;
